import { Separator } from '@wartek-id/separator'
import { Text } from '@wartek-id/text'

import { titleCaseContainsSatdik } from '@/utils/string'
import { District, EducationLevel, StatisticTable } from '@/apis/types'

import { LinkWithTracker } from '@/components/LinkWithTracker'

interface DatasetItemProps {
  item: StatisticTable
  educationLevel: EducationLevel
  year: number
  district?: District
  indexItem: string
}

export const DatasetItem = ({
  item,
  educationLevel,
  year,
  district,
  indexItem,
}: DatasetItemProps) => {
  return (
    <div className="flex w-full gap-2 border-t pt-6" data-index={indexItem}>
      <div className="flex flex-col gap-2">
        <LinkWithTracker
          href={`/dataset/detail/${item.tableNum}/L${district?.districtLevel}-${district?.id}/${year}/${educationLevel.name}-${educationLevel.id}`}
          data-testid={`link-dataset-${indexItem}`}
        >
          <Text variant="heading-md">{titleCaseContainsSatdik(item.name)}</Text>
        </LinkWithTracker>
        <div className="flex items-center gap-2">
          {district ? (
            <>
              <Text
                variant="helper"
                color="subdued"
                data-testid={`txt-district-${indexItem}`}
              >
                {district.name}
              </Text>
              <Separator
                style={{
                  width: 1,
                  height: 18,
                }}
              />
            </>
          ) : null}

          {year ? (
            <>
              <Text
                variant="helper"
                color="subdued"
                data-testid={`txt-year-${indexItem}`}
              >
                Tahun {year}/{year + 1}
              </Text>
              <Separator
                style={{
                  width: 1,
                  height: 18,
                }}
              />
            </>
          ) : null}

          <Text
            variant="helper"
            color="subdued"
            data-testid={`txt-edu-level-${indexItem}`}
          >
            {educationLevel.name}
          </Text>
        </div>
      </div>
    </div>
  )
}
